var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "bo_nav_headline", class: { loggedInUser: _vm.isLoggedIn } },
    [
      !_vm.inHeader
        ? [
            _c(
              "div",
              { staticClass: "sb_title" },
              [
                _vm.currentBoNavigation && _vm.currentBoNavigation.imageicon
                  ? _c("icon", {
                      attrs: { name: _vm.currentBoNavigation.imageicon }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _c("h1", [
                  _vm._v(
                    _vm._s(
                      (_vm.currentBoNavigation &&
                        _vm.currentBoNavigation.name) ||
                        _vm.title
                    )
                  )
                ])
              ],
              1
            ),
            _vm._v(" "),
            _c("h3", [
              _vm._v(
                _vm._s(
                  _vm.currentBoNavigation &&
                    (_vm.currentBoNavigation.description ||
                      _vm.currentBoNavigation.internaldescription)
                )
              )
            ])
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.inHeader
        ? [
            _vm.mobileBigAndBelow &&
            _vm.isParlayZone === _vm.$t("Parlay.Zone.Title")
              ? _c("div", { staticClass: "pp_header" }, [
                  _c("div", { staticClass: "header-title" }, [
                    _c("span", { staticClass: "pp_icon" }),
                    _vm._v(" "),
                    _c("h1", {
                      domProps: {
                        innerHTML: _vm._s(_vm.$t("Parlay.Zone.Title"))
                      }
                    })
                  ])
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.mobileBigAndBelow && _vm.isBetZone === _vm.$t("Bet.Zone.Title")
              ? _c("div", { staticClass: "pp_header" }, [
                  _c("div", { staticClass: "header-title" }, [
                    _c("span", { staticClass: "betzone_icon" }),
                    _vm._v(" "),
                    _c("h1", {
                      domProps: { innerHTML: _vm._s(_vm.$t("Bet.Zone.Title")) }
                    })
                  ])
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.isFastSwitchEnabled && (_vm.idFwMarketgroup || _vm.liveEvent)
              ? _c(
                  "div",
                  {
                    staticClass: "fast_switch_title",
                    on: { click: _vm.toggleFastSwitch }
                  },
                  [
                    _c(
                      "h1",
                      [
                        _vm.liveEvent
                          ? _c("icon", { attrs: { name: "icon-live" } })
                          : _vm._e(),
                        _vm._v(
                          _vm._s(
                            (_vm.event && _vm.event.fosportname) ||
                              (_vm.event && _vm.event.sportname)
                          )
                        )
                      ],
                      1
                    ),
                    _c(
                      "span",
                      { staticClass: "arrow_down" },
                      [_c("v-icon", [_vm._v("keyboard_arrow_down")])],
                      1
                    )
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            !(_vm.currentBoNavigation && _vm.currentBoNavigation.name) &&
            _vm.pageTitle &&
            _vm.$te("PageTitle." + _vm.pageTitle)
              ? _c(
                  "h1",
                  { class: { "title-live": _vm.pageTitle === "live" } },
                  [
                    _vm._v(_vm._s(_vm.$t("PageTitle." + _vm.pageTitle)) + " "),
                    _vm.pageTitle === "live"
                      ? _c("icon", { attrs: { name: "icon-live" } })
                      : _vm._e()
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            !_vm.isFastSwitchEnabled && _vm.liveEvent
              ? _c(
                  "h1",
                  { staticClass: "title-live" },
                  [
                    _vm._v(_vm._s(_vm.$t("PageTitle.live")) + " "),
                    _c("icon", { attrs: { name: "icon-live" } })
                  ],
                  1
                )
              : _vm._e()
          ]
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2e2ba974", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2e2ba974","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/sports/bettingoffer/sportsBreadcrumb.vue
// module id = null
// module chunks = 